export default {"src":"/_next/static/media/brokerIcon.ff63ad0e.svg","height":24,"width":24};